/* eslint-disable react/jsx-indent */
/* eslint-disable prettier/prettier */
import React from 'react'
import PropTypes from 'prop-types'
import BoxRounded from '../BoxRounded/BoxRounded'
import Flex from '../Flex/Flex'
import Text from '../Text/Text'
import styles from './ratingBox.module.scss'

const RatingBox = (props) => {
  const { title, subtitle, updatedAt, classification } = props

  return (
    <BoxRounded margin="10px 15px 0px 0px" height="140px">
      <Flex>
        <Flex column>
          <Text size="xxs" color="gray" variation="dark" bold>
            {title}
          </Text>
          {classification ? (
            <Flex alignItems="flex-start" margin="13px 0px">
              <div className={styles.containerRating}>
                <Text color="white">{classification}</Text>
              </div>
            </Flex>
          ) : (
            <Text
              size="sm"
              color="gray"
              variation="dark"
              extraBold
              margin="16px 0px"
            >
              {subtitle}
            </Text>
          )}

          <Text size="xxs" color="gray" variation="light" font="custom">
            {updatedAt}
          </Text>
        </Flex>
      </Flex>
    </BoxRounded>
  )
}

RatingBox.defaultProps = {
  classification: null
}

RatingBox.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
  classification: PropTypes.string
}

export default RatingBox
